/**
 * Licensed Materials - Property of ROOTCLOUD
 * THIS MODULE IS "RESTRICTED MATERIALS OF ROOTCLOUD"
 * (c) Copyright ROOTCLOUD Inc. 2021 All Rights Reserved
 *
 * The source code for this program is not published or
 * otherwise divested of its trade secrets
 */
/*
 * @Description:
 * @Autor: xiaona.wang
 * @Date: 2021-07-22 17:11:59
 *
 * @LastEditors: yingna.gao
 * @LastEditTime: 2022-09-07 19:55:40
 */
import Vue from "vue";

// Normalize.css是一种CSS reset的替代方案。
import "normalize.css/normalize.css";

// ElementUI组件库
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";

// set ElementUI lang to EN
import zhLocale from "element-ui/lib/locale/lang/zh-CN"; // 引入中文版
Vue.use(ElementUI, { zhLocale });

import "@/directive";
import "@/assets/svg"; // icon
import "@/permission"; // permission control
import "@/styles/tailwind/tailwind.css";

// import locale from "element-ui/lib/locale/lang/en"; // lang i18n
import "@/styles/index.scss"; // global css

import App from "./App";
import store from "./store";
import router from "./router";
import i18n from "@/assets/lang"; // internationalization
import Pagination from "@/components/common/Pagination/index";
import { getExtendLabel, visibleRes, disableRes, getResLabel } from "@/utils/resource_permission";
import { registerComponents } from "@/utils/utils";
Vue.component("Pagination", Pagination);

import Skeleton from "@/plugin/skeleton";
import components from "@/plugin/components";
Vue.use(Skeleton);
Vue.use(components.install);
// 按钮级权限
Vue.prototype.getExtendLabel = getExtendLabel;
Vue.prototype.visibleRes = visibleRes;
Vue.prototype.disableRes = disableRes;
Vue.prototype.getResLabel = getResLabel;

// 全局注册table
import TreeSelect from "@/components/private/tree-select";
import CustomTable from "@/components/private/table";
import EdmCustomTable from "@/components/private/edm-table";
// 全局注册table
import GeneralTable from "@/components/common/GeneralTable";
import TreeListLayoutAdapter from "@/layout/components/TreeListLayoutAdapter";

import { apiInstall } from "./api/index";
Vue.use(apiInstall);
Vue.component("TreeSelect", TreeSelect);
Vue.component("CustomTable", CustomTable);
Vue.component("GeneralTable", GeneralTable);
Vue.component("TreeListLayoutAdapter", TreeListLayoutAdapter);
Vue.component("EdmCustomTable", EdmCustomTable);
const componentsList = registerComponents({ fileList: require.context("./components", true, /index\.js$/), filter: ["common", "private", "RcBase"] });
Object.keys(componentsList).map(item => {
  Vue.component(item, componentsList[item]);
});

// 注册常量，用于编码、名称字符限制
import { InputMaxLimit } from "@/utils/settings";
Vue.use(InputMaxLimit);

/*
 * 如果想要中文版 element-ui，按如下方式声明
 * Vue.use(ElementUI)
 */
// import { Table } from 'element-ui';
// // import StickyTable from "element-ui-sticky-table";
// delete Table._Ctor;
// Vue.component(Table.name, resolve => {
//   const { bindEvents } = Table.methods;
//   Object.assign(Table.methods, {
//     bindEvents() {
//       bindEvents.call(this);
//       this.bodyWrapper.addEventListener('mousewheel', this.handleBodyMousewheel);
//     },
//     handleBodyMousewheel(event) {
//       const { fixedWrapper } = this.$refs;
//       if (fixedWrapper) {
//         const fixedBodyWrapper = fixedWrapper.querySelector('.el-table__fixed-body-wrapper');
//         if (fixedBodyWrapper) {
//           event.preventDefault();
//           fixedBodyWrapper.scrollBy({ left: event.deltaX, top: event.deltaY });
//           this.$refs.bodyWrapper.scrollBy({ left: event.deltaX, top: event.deltaY });
//         }
//       }
//     }
//   });
//   resolve(Table);
// });
// 滑动验证码
import SlideVerify from "vue-monoplasty-slide-verify";
Vue.use(SlideVerify);

Vue.config.productionTip = false;

import "@/globals";

// eslint-disable-next-line vue/require-name-property
new Vue({
  el: "#scim-common-web",
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#scim-common-web");
